const BRAND_STYLE =
  'background: linear-gradient(135deg, #fe0000 0%, #ff4d57 100%); color: #fff; padding: 3px 9px; border: 1px solid #fe0000; border-radius: 4px; font-weight: 800; letter-spacing: 0.05em; text-shadow: 0 1px 1px rgba(128, 0, 0, 0.24);';
const MODULE_STYLE = 'color: #7c3aed; font-weight: 700;';
const MESSAGE_STYLE = 'color: inherit;';

/**
 * 输出外部浏览器无法调用原生能力的统一提示。
 */
export const printNativeMethodFallback = (
  apiName: string,
  nativeMethodNames: string | readonly string[],
  fallbackDescription?: string,
): void => {
  const methods = Array.isArray(nativeMethodNames) ? nativeMethodNames.join(', ') : nativeMethodNames;
  const fallback = fallbackDescription ? `；已改用${fallbackDescription}` : '';

  console.warn(
    '%c HRHG APPLICATION %c AppBridge %c 外部浏览器环境无法调用 Native Handler：%s（API：%s）%s',
    BRAND_STYLE,
    MODULE_STYLE,
    MESSAGE_STYLE,
    methods,
    apiName,
    fallback,
  );
};
